import styled from 'styled-components';
import { cssVar } from 'styles/helper';
import Stack from 'atoms/Layout/Stack/Stack';

export const HubspotFormWrapperContainer = styled(Stack)`
  width: 100%;
  flex: 1;

  form {
    input[type='submit'] {
      display: none; // we are going to use our own submit button
    }
  }

  &.hide-legal {
    .legal-consent-container {
      display: none;
    }
  }

  // force 2 columns into 1
  &.force-one-input-per-column {
    .form-columns-2,
    .form-columns-1 {
      display: block;

      div.hs-form-field {
        width: 100%;
        margin-bottom: ${cssVar('spacing-xl')};
        margin-right: initial;
        float: left !important; // force each input to be on its own line
      }
    }
  }

  // hide input labels
  &.hide-input-labels {
    .form-columns-2,
    .form-columns-1 {
      div.hs-form-field {
        .hs-field-desc {
          display: none !important;
        }
      }
    }
  }

  // form styling
  form {
    width: 100%;

    fieldset {
      // legal text styling
      .legal-consent-container {
        font-size: ${cssVar('font-size-text-xs')};
        line-height: ${cssVar('line-height-text-xs')};
        font-weight: ${cssVar('font-weight-regular')};
        text-align: center;
      }

      // styling input and label for this specific form
      &.form-columns-2,
      &.form-columns-1 {
        max-width: initial;
        margin: 0 auto;
        display: flex;

        div.hs-form-field {
          width: 100%;

          &:not(:last-child) {
            margin-right: ${cssVar(
              'spacing-xl'
            )}; // this is the space between the input fields when they are in the same row
          }

          // styling for label, when the .hs-field-desc does not exist
          label {
            display: flex;
            margin-bottom: ${cssVar('spacing-sm')};
            font-weight: ${cssVar('font-weight-medium')};
            color: ${cssVar('text-secondary')};

            span.hs-form-required {
              color: ${cssVar('text-brand-secondary')};
              padding-left: ${cssVar('spacing-xxs')};
            }

            &.hs-error-msg {
              color: ${cssVar('text-error-primary')};
            }
          }

          .hs-field-desc {
            font-weight: ${cssVar('font-weight-semibold')};
            margin-bottom: ${cssVar('spacing-sm')};
          }

          .input {
            margin-right: 0;

            input,
            select,
            textarea.hs-input.hs-fieldtype-textarea {
              width: 100%;
              border-radius: ${cssVar('radius-md')};
              border: 1px solid ${cssVar('border-primary')};
              background-color: ${cssVar('bg-primary')};
              padding: 10px 14px;
              box-sizing: border-box;
              outline: none;

              font-size: ${cssVar('font-size-text-md')};
              line-height: ${cssVar('line-height-text-md')};
              font-weight: ${cssVar('font-weight-regular')};
              font-family: ${cssVar('font-family-body')};

              transition: all 0.2s ease-in-out;
              box-shadow: ${cssVar('shadow-xs')};

              &:focus {
                border-color: ${cssVar('border-secondary')};
              }

              &:focus-within {
                border-color: ${cssVar('border-brand')};
                box-shadow: 0 0 0 2px ${cssVar('focus-ring')};
              }

              &::placeholder {
                color: ${cssVar('text-placeholder')};
              }
              &.is-placeholder {
                color: ${cssVar('text-placeholder')};
              }
            }

            textarea.hs-input.hs-fieldtype-textarea {
              min-height: 112px; // custom height for textarea
            }

            input[type='checkbox'],
            input[type='radio'] {
              width: initial;
              border-radius: initial;
              border: initial;
              background-color: initial;
            }
          }
        }

        div.legal-consent-container {
          ul {
            li.hs-form-booleancheckbox {
              label.hs-form-booleancheckbox-display {
                color: ${cssVar('text-tertiary')};
                text-align: left;
                & > span {
                  margin-left: ${cssVar('spacing-3xl')};
                }
                p {
                  text-align: left;
                  > a {
                    text-decoration: underline;
                    color: inherit;
                  }
                }
              }
            }
          }
        }

        ul {
          padding: 0;
          margin-top: ${cssVar('spacing-lg')};
          margin-bottom: 0px;

          li {
            list-style: none;

            &.hs-form-booleancheckbox,
            &.hs-form-radio {
              margin-top: ${cssVar('spacing-xl')};
              margin-bottom: ${cssVar('spacing-xl')};
              font-size: ${cssVar('font-size-text-md')};
              max-width: ${cssVar('width-sm')};

              input[type='checkbox'] {
                margin-top: 2px;
                width: auto !important;
              }
            }

            &.hs-form-radio {
              .hs-form-radio-display {
                column-gap: ${cssVar('spacing-md')};
                align-items: center;
                column-gap: ${cssVar('spacing-md')};
                cursor: pointer;
                font-weight: 300;
                min-height: auto;

                input[type='radio'] {
                  width: 20px;
                  height: 20px;
                  flex: 0 0 20px;
                }
              }
            }
          }
        }

        div.hs-fieldtype-checkbox.field.hs-form-field {
          margin-top: ${cssVar('spacing-xl')};

          label {
            box-sizing: border-box;
            line-height: unset;
            font-size: ${cssVar('font-size-text-md')};
            display: flex;
            margin-bottom: 0px;
            white-space: break-spaces;

            &.hs-error-msg {
              color: ${cssVar('text-error-primary')};
            }
          }
        }

        div.hs-fieldtype-checkbox {
          .hs-form-checkbox {
            .hs-form-checkbox-display {
              align-items: center;
              column-gap: ${cssVar('spacing-md')};
              cursor: pointer;
              font-weight: 300;
              min-height: auto;

              input[type='checkbox'] {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
    }

    // error styling
    .hs-error-msgs {
      margin: ${cssVar('spacing-md')} ${cssVar('spacing-none')};
      font-size: ${cssVar('font-size-text-sm')};
      color: ${cssVar('text-error-primary')};
      list-style-type: none;
      padding-left: 0;
      text-align: left;

      label.hs-error-msg {
        color: inherit;
      }
    }
  }
`;
